import { render, staticRenderFns } from "./CreateLevelModal.vue?vue&type=template&id=774dc98e&scoped=true"
import script from "./CreateLevelModal.vue?vue&type=script&lang=js"
export * from "./CreateLevelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774dc98e",
  null
  
)

export default component.exports